
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalFlag as ObiBuoyConicalFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-flag.js';
 
 
 

 
 export const ObiBuoyConicalFlag = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-flag',
   elementClass: ObiBuoyConicalFlagElement,
   events: {
     
   }
  });
 
 